import { useCallback } from 'react';
import { useQuery } from "react-query";
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import { useEditor } from './EditorProvider';
import { SET_CURRENT_ELEMENT } from './types'
import { useProfile } from '../../api/hooks/profile';

export function useEditorActions() {
  const { profile } = useProfile();
  const [state, dispatch] = useEditor()
  const { t } = useTranslation('common');

  const checkMissingSignatures = useCallback(() => {
    let missingSignatures = false;
    const missingParticipants = [];
    state.participants.map((participant) => {
      if (!state.signatures[participant._id]?.length) {
          missingSignatures = true
          missingParticipants.push(participant.label)
      }
  })

    if (missingSignatures && state.isPdf && state.signatureType === 'autograph') {
      toast.error( t('errorMessages.missingSignatures', { participants: missingParticipants.slice(0, 4).join(', ') }))
      return true;
    }

    return false;
  }, [state.signatureType, state.participants, state.signatures, state.isPdf, t])

  const checkCredits = useCallback(() => {
    let type = 1;
    let hasNoCredits = false;

    if (profile?.externalStorageConfig?.saveOn === 'trato' && profile?.storage?.remaining <= 0) {
        toast.error(t('noMoreStorage'), {
            position: toast.POSITION.TOP_RIGHT
        })
        return true;
    }

    const shield3CreditsUse = state.participants.filter(p => p.requestAgreement).length;

    if (profile.shield3.remaining < shield3CreditsUse) {
        type = 3;
        hasNoCredits = true;
    } else if (state.shieldType.value === 'shield2' && profile.nom151.remaining <= 0) {
        type = 2;
        hasNoCredits = true;
    } else if (state.shieldType.value === 'shield1' && profile.contracts.remaining <= 0) {
        type = 1;
        hasNoCredits = true;
    }
  
 

    if (hasNoCredits) {
        const shieldType = t('shield', { context: 'number', number: type });
        const noMoreCreditsText = t('noMoreCredits', { context: 'type', type: shieldType })
        toast.error(noMoreCreditsText, {
            position: toast.POSITION.TOP_RIGHT
        })
    }

    return hasNoCredits;
  }, [profile, state.shieldType, t, state.participants])

  const checkSignatureCredits = useCallback(() => {
    let type = '';
    let hasNoCredits = false;

    if (state.signatureType === 'certificate' && profile.fiels?.remaining <= 0) {
        type = 'fiel';
        hasNoCredits = true;
    }
  

    if (hasNoCredits) {
        const shieldType = t('signature', { context: type });
        const noMoreCreditsText = t('noMoreCredits', { context: 'type', type: shieldType })
        toast.error(noMoreCreditsText, {
            position: toast.POSITION.TOP_RIGHT
        })
    }

    return hasNoCredits;
  }, [profile, state.signatureType, t])

  const setCurrentElement = (element) => {
    dispatch({ type: SET_CURRENT_ELEMENT, element })
  }

  return {
    checkMissingSignatures,
    checkCredits,
    checkSignatureCredits,
    setCurrentElement
  }
}